import { apiClient } from '../../services/api';

import i18next, {t} from 'i18next';

import { deauthenticate } from '../../Authentication/actions';
import { DEAUTHENTICATE_USER } from '../../Authentication/reducer';
import {DELETE_USER} from "./reducer";
import log from 'loglevel'
import { pingURL, sendRequest  } from '../../services/api/apiClient';
import toast from '../../utils/ToasterService';

/**
 *
 * @param data: {forename, surname, email, password, telephone}
 * @param successCb
 * @param errorCb
 * @returns {Function}
 */
const checkConnectionToServer=()=>{
    sendRequest('get', pingURL)
    .then(() => {
      //console.log('Response Ok: Server working!');
    })
    .catch(error => {
      //console.error('Cannot Connect to Server:', error);
      //Server Failure Toast here
      toast.error(t('Global.toast_server_disconnect'));
    });
  }

export function registerUser(data, successCb, errorCb) {
    checkConnectionToServer()
    return function(dispatch, getState) {
        apiClient.post('users/', data)
            .then((response) => {
                if (response.status === 201 || response.status === 202) {
                    successCb();
                }
            })
            .catch((e) => {
                const { response } = e;
                log.error('RESPONSE ', response)

                if (response && response.status === 400 && response.data.param === 'password') {
                    errorCb({msg: t('Registration.textfield_helpertext_password')})
                } else {
                    errorCb({msg: t('Global.toast_error')})
                }
                dispatch(hasError(e.message, e));
            });
    }
}

/**
 *
 * @param successCb
 * @param errorCb
 * @returns {Function}
 */
export function deleteUser(successCb, errorCb) {
    checkConnectionToServer()
    return function(dispatch, getState) {
        apiClient.delete('users/')
            .then((response) => {
                if (response.status === 204) {
                    dispatch(deauthenticate());
                    dispatch({
                        type: DELETE_USER
                    });
                    successCb();
                }
            })
            .catch((e) => {
                errorCb({msg: t('Global.toast_error')})
                dispatch(hasError(e.message, e));
            });
    }
}

export function changePassword(currentPw, newPw, successCb, errorCb) {
    checkConnectionToServer()
    return function(dispatch, getState) {
        const { authentication: {user, accessToken} } = getState();
        const language = i18next.language;
        apiClient.put('users/' + user._id +'/changePassword?access_token='+accessToken, {
            currentPw,
            newPw,
            password: currentPw,
            language
        })
            .then((response) => {
                if (response.status === 200) {
                    successCb();
                }
            })
            .catch((e) => {
                const { data: responseData } = e.response;
                if(responseData.errorCode === 'CURRENT_PW_INVALID') {
                    errorCb({msg: t('PasswordNew.toast_error_wrong_password')})
                } else {
                    errorCb({msg: t('Global.toast_error')})
                }
                dispatch(hasError(e.message, e));
            });
    }
}

export function requestResetPwMail(email, successCb, errorCb) {
    checkConnectionToServer()
    return function(dispatch, getState) {
        const link = window.location.href;
        const language = i18next.language;
        apiClient.post('password-resets', {
            email,
            link,
            language
        })
            .then((response) => {
                if (response.status === 202) {
                    successCb();
                }
            })
            .catch((e) => {
                const { data: responseData } = e.response;
                if(responseData.errorCode === 'NO_USER_FOUND') {
                    errorCb({msg: t('PasswordReset.toast_error_no_user')})
                } else {
                    errorCb({msg: t('Global.toast_error')})
                }
                dispatch(hasError(e.message, e));
            });
    }
}

export function setNewPassword(password, successCb, errorCb) {
    checkConnectionToServer()
    return function(dispatch, getState) {
        let token = '';
        const language = i18next.language;
        try {
            const routes = window.location.href.split('/');
            token = routes[routes.length-1];
        } catch (e) {
            log.error('Couldnt extract token', e);
        }

        apiClient.put('password-resets/' + token, {
            password,
            language
        })
            .then((response) => {
                if (response.status === 200) {
                    successCb();
                }
            })
            .catch((e) => {
                const { data: responseData } = e.response;
                if(responseData.errorCode === 'TOKEN_INVALID') {
                    errorCb({msg: t('PasswordNew.toast_error_token_invalid')})
                } else {
                    errorCb({msg: t('Global.toast_error')})
                }
                dispatch(hasError(e.message, e));
            });
    }
}

export function fetchCurrentUser(successCb, errorCb) {
    return function(dispatch, getState) {
        apiClient.get('users/me')
            .then((response) => {
                dispatch({
                    type: "UPDATE_CURRENT_USER",
                    currentUser:response.data
                });
                if(successCb) successCb();
            })
            .catch((e) => {

            });
    }
}


/**
* hasError
* @param {string}   cause
* @param {Object}  exception
* @return {Action}   action
*/
function hasError(param, message) {
    if (param === "Request failed with status code 401") {
        return { type: DEAUTHENTICATE_USER}
      }
return { type: 'ERROR', param, message };
}

